/**
 * Returns true if alt or option keys were pressed.
 */
export default (event) => {
      return event.altKey; // Windows, Linux, UNIX, MACOS
};